import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class ApiUrlService {
    [key: string]: unknown

    public readonly employeeTypes: string = '/employeeTypes'
    public readonly employees: string = '/employees'
    public readonly employeesQuery: string = '/employees/query'
    public readonly employeesWithId: string = '/employees/{id}'
    public readonly leaveType: string = '/leaveTypes'
    public readonly leaves: string = '/leaves'
    public readonly leavesQuery: string = '/leaves/query'
    public readonly leavesWithId: string = '/leaves/{id}'
    public readonly shipTypes: string = '/shipTypes'
    public readonly ships: string = '/ships'
    public readonly shipsTypesWithId: string = '/shipTypes/{id}'
    public readonly shipsWithId: string = '/ships/{id}'
    public readonly skills: string = '/skills'
    public readonly skillsWithId: string = '/skills/{id}'
    public readonly leaveStatDays: string = '/statDays'
    public readonly publicHolidays: string = '/publicHolidays/query'
    public readonly publicHolidaysWithId: string = '/publicHolidays/{id}'
    public readonly labourSheetCounters: string = '/labourSheetCounters'
    public readonly reportPeriods: string = '/reportPeriods'
    public readonly employeeLabourCodes: string = '/employeeLabourCodes'
    public readonly labourSheets: string = '/labourSheets'
    public readonly labourSheetQuery: string = '/labourSheets/query'
    public readonly labourSheetWithId: string = '/labourSheets/{id}'
    public readonly labourSheetRollback: string = '/rollbackLabourSheet'
    public readonly employeeReport: string = '/employeeReport'
    public readonly labourReport: string = '/labourReport'
    public readonly labourSheetsPreview: string = '/labourSheets/preview/{id}'
    public readonly labourReportPreview: string = '/labourReport/preview'

    public setApiUrl(apiUrl: string): void {
        const propertyNames = Object.getOwnPropertyNames(this)
        for (const propName of propertyNames) {
            const url = this[propName]
            if (typeof url === 'string' && !url.includes('https://') && !url.includes('http://')) {
                this[propName] = apiUrl + url
            } else {
                this[propName] = '' + url
            }
        }
    }
}
